import React, { useState } from 'react'

import { Attraction } from 'src/interfaces/Attraction'
import { useWindowWidth } from 'src/hooks/useWindowWidth'
import { EventSubSection } from 'src/components/EventSubSection/EventSubSection'

import { MAX_ATTRACTIONS_TO_DISPLAY } from '../constants'

import { AttractionCard } from './AttractionCards/AttractionCard'

const style = require('./AttractionsSection.css')

export interface AttractionsSubSectionProps {
  title: string,
  attractions: Attraction[],
  createOnSelect: (attraction: Attraction) => () => void,
  singleSubSectionClass?: string,
}

export const AttractionsSubSection = ({
  title,
  attractions,
  createOnSelect,
  singleSubSectionClass,
}: AttractionsSubSectionProps) => {
  const { isDesktop } = useWindowWidth()

  const [isViewAll, setIsViewAll] = useState<boolean>(false)

  const isShowingAll = isViewAll || !isDesktop
  const isViewAllButtonDisplayed = isDesktop && attractions.length > MAX_ATTRACTIONS_TO_DISPLAY

  const displayedAttractions
    = isShowingAll ? attractions : attractions.slice(0, MAX_ATTRACTIONS_TO_DISPLAY)

  const viewAllToggle = () => setIsViewAll(!isViewAll)

  return (
    <EventSubSection
      title={title}
      extendedClassName={singleSubSectionClass}
      viewAllHandler={isViewAllButtonDisplayed && viewAllToggle}
      isShowingAll={isViewAll}
    >
      <div className={style.attractionsSubSectionContainer}>
        {
          displayedAttractions.map(attraction => (
            <AttractionCard
              key={attraction.id}
              attraction={attraction}
              onClick={createOnSelect(attraction)}
            />
          ))
        }
      </div>
    </EventSubSection>
  )
}
